/**
 * Professional Search Enhancement
 * - Shows popular searches on focus
 * - Smooth animations
 * - Keyboard navigation
 */
(function() {
  'use strict';
  
  function init() {
    const searchInput = document.querySelector('.search-bar__input');
    const searchForm = document.querySelector('.search-bar');
    const popularContainer = document.querySelector('[data-search-popular]');
    
    if (!searchInput || !popularContainer) return;
    
    // Show popular on focus (when input is empty)
    searchInput.addEventListener('focus', function() {
      if (this.value.trim() === '') {
        showPopular();
      }
    });
    
    // Hide on input (when user types)
    searchInput.addEventListener('input', function() {
      if (this.value.trim() !== '') {
        hidePopular();
      } else {
        showPopular();
      }
    });
    
    // Hide on click outside
    document.addEventListener('click', function(e) {
      if (searchForm && !searchForm.contains(e.target)) {
        hidePopular();
      }
    });
    
    // Handle popular search clicks
    popularContainer.addEventListener('click', function(e) {
      const link = e.target.closest('[data-popular-search]');
      if (link) {
        const query = link.dataset.popularSearch;
        searchInput.value = query;
        // Let the link navigate
      }
    });
    
    // Keyboard navigation
    searchInput.addEventListener('keydown', function(e) {
      if (!popularContainer.classList.contains('is-visible')) return;
      
      const links = popularContainer.querySelectorAll('.search-bar__popular-link');
      if (links.length === 0) return;
      
      const focusedIndex = Array.from(links).findIndex(l => l === document.activeElement);
      
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = focusedIndex < links.length - 1 ? focusedIndex + 1 : 0;
        links[nextIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = focusedIndex > 0 ? focusedIndex - 1 : links.length - 1;
        links[prevIndex].focus();
      } else if (e.key === 'Escape') {
        hidePopular();
        searchInput.blur();
      }
    });
    
    function showPopular() {
      popularContainer.classList.add('is-visible');
      popularContainer.setAttribute('aria-hidden', 'false');
    }
    
    function hidePopular() {
      popularContainer.classList.remove('is-visible');
      popularContainer.setAttribute('aria-hidden', 'true');
    }
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
